<template>
  <crud-create
    :open="open"
    :loading="loading"
    :title="title"
    :errorMessage="errorMessage"
    @create="create"
    @close="$emit('close')"
  >
    <producto-form
      ref="form"
      operation="creating"
      v-model="form"
      :input-errors="inputErrors"
    />
  </crud-create>
</template>

<script>
import ProductoProvider from "../../../providers/ProductoProvider";
import UserConfigurationProvider from "../../../../user-configuration/providers/UserConfigurationProvider";

import { CrudCreate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";

import ProductoForm from "../ProductoForm";

export default {
  name: "ProductoCreate",

  components: { ProductoForm, CrudCreate },

  props: {
    open: { type: Boolean, default: true },
  },

  data() {
    return {
      title: "producto.creating",
      errorMessage: "",
      inputErrors: {},
      loading: false,
      form: {
        marca: {
          id: null,
          nombre: null,
        },
        modelo: {
          id: null,
          nombre: null,
        },
        tamanio: {
          id: null,
          tamanio: null,
        },
        nombre: "",
        nombreAutogenerado: true,
        codigoBarras: "",
        codigoBarrasProveedor: "",
        proveedorId: null,
        productoProveedorPrecioActivoId: null,
        precioCompra: null,
        stock: null,
        stockAlerta: null,
        fechaVencimiento: null,
        fechaAlta: null,
        fechaUltimaModificacion: null,
        creadoPor: null,
        depositoInfo: null,
        deposito: null,
        descuentoProveedor: 0,
        ivaPorcentaje: 0,
        porcentajeSobreCosto: 0,
        tipoRedondeo: null,
        otrasCaracteristicas: "",
      },
    };
  },

  mounted() {
    this.loadUserConfiguration();
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.loadUserConfiguration();
      }
    },
  },

  methods: {
    loadUserConfiguration() {
      UserConfigurationProvider.getUserConfiguration(true)
        .then((r) => {
          if (r && r.data && r.data.userConfigurationGet) {
            const config = r.data.userConfigurationGet;
            let nombreDeposito = null;
            if (config.deposito && config.deposito.nombre) {
              nombreDeposito = config.deposito.nombre;
            } else if (config.depositoIdSeleccionado && config.depositos && config.depositos.length > 0) {
              const dep = config.depositos.find(
                (d) => String(d.id) === String(config.depositoIdSeleccionado)
              );
              if (dep) nombreDeposito = dep.nombre;
            }
            if (nombreDeposito) {
              this.form.depositoInfo = nombreDeposito;
            }
            if (config.depositoIdSeleccionado) {
              this.form.deposito = config.depositoIdSeleccionado;
            }
          }
        })
        .catch((error) => {
          console.error("Error loading user configuration:", error);
          this.errorMessage = "No se pudo cargar la configuración del depósito. Por favor, configure un depósito antes de crear productos.";
        });
    },
    async create() {
      this.$refs.form.syncCodigoBarrasProveedorDesdeChips();
      if (!this.$refs.form.validate()) return;
      // Sincronizar precio de compra del campo activo (precioCompraActivoEdit) al form para que se envíe en productoCreate
      const precioActivo = this.$refs.form.precioCompraActivoEdit;
      this.form.precioCompra =
        precioActivo != null && precioActivo !== "" ? Number(precioActivo) : null;
      this.loading = true;
      try {
        const r = await ProductoProvider.createProducto(this.form);
        const producto = r?.data?.productoCreate;
        if (!producto) return;
        const preciosProveedor = this.$refs.form.preciosProveedor || [];
        for (let i = 1; i < preciosProveedor.length; i++) {
          const pp = preciosProveedor[i];
          if (pp?.proveedorId && pp?.codigoBarrasProveedor) {
            await ProductoProvider.upsertProductoProveedorPrecio({
              productoId: producto.id,
              proveedorId: pp.proveedorId,
              codigoBarrasProveedor: (pp.codigoBarrasProveedor || "").trim(),
              precioCompra: pp.precioCompra || null,
              descuentoProveedor: pp.descuentoProveedor ?? null,
            });
          }
        }
        this.$emit("itemCreated", producto);
        this.$emit("close");
      } catch (error) {
        const clientError = new ClientError(error);
        this.inputErrors = clientError.inputErrors;
        this.errorMessage = clientError.i18nMessage;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
